import React, { useState } from "react";
import { FilterMatchMode } from "primereact/api";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import { Button } from "primereact/button";
import { InputText } from "primereact/inputtext";
import { Tag } from "primereact/tag";
import "../schools/SchoolsTable.css";
import { empty } from "../../../../Utilities/utils";
import { NavLink, useNavigate } from "react-router-dom";
import colors from "../../../../config/colors";
import { Checkbox } from "primereact/checkbox";
import { FaCheck } from "react-icons/fa";

export default function StudentsTable({
  students,
  getStudentReportScreen,
  onPageChange,
  rows = 50,
  totalRecords,
  first,
  search = "",
  onSearchChange,
  onKeyDown,
  assessment = false,
  openAssessmentModal,
  recordScores = false,
  reportSheet = false,
  openMultipleAssessmentModal,
  isClassList = false,
  isPromotionList = false,
  openPaymentAlert,
  selectedStudentIds = [],
  setShowAddButton,
  setSelectedStudentIds,
  setChecked,
  updateSelectedStudentIds,
  checked,
  studentIds,
  promoteStudent,
  activateEmpty,
  graduationList = false,
}) {
  const navigate = useNavigate();
  const [filters, setFilters] = useState({
    global: { value: null, matchMode: FilterMatchMode.CONTAINS },
  });
  const [selectedStudent, setSelectedStudent] = useState(null);

  const getSeverity = (status) => {
    switch (status) {
      case false:
        return "danger";

      case true:
        return "success";
      default:
        return "danger";
    }
  };

  const statusBodyTemplate = (rowData) => {
    return (
      <Tag
        value={
          !empty(rowData) && !empty(rowData.active) ? "ACTIVE" : "IN-ACTIVE"
        }
        severity={getSeverity(
          !empty(rowData) && !empty(rowData.active) ? rowData.active : false
        )}
      />
    );
  };

  // go to profile
  const goToProfile = (rowData) => {
    const studentId = !empty(rowData) && !empty(rowData._id) ? rowData._id : "";
    navigate(`/student/${studentId}/profile`);
  };

  const renderHeader = () => {
    return (
      <div className="p-inputgroup">
        <span className="p-inputgroup-addon">
          <i className="pi pi-search"></i>
        </span>
        <InputText
          type="search"
          value={search}
          onChange={onSearchChange}
          onKeyDown={onKeyDown}
          placeholder="Student Search"
        />
      </div>
    );
  };

  const actionBodyTemplate = (rowData) => {
    const hasPaid =
      !empty(rowData) && !empty(rowData.paid) && rowData.paid === "Yes"
        ? true
        : false;
    return (
      <div style={{ display: "flex", gap: 8 }}>
        {assessment ? (
          <>
            {recordScores && (
              <>
              <Button
                icon="pi pi-cloud-upload"
                style={{
                  width: 35,
                  height: 35,
                  backgroundColor: "transparent",
                  color: "#22C55E",
                  borderColor: "#22C55E",
                  borderWidth: 1,
                  borderRadius: "50%",
                }}
                onClick={() => openAssessmentModal(rowData)}
              />
              <Button
                icon="pi pi-arrow-circle-up"
                style={{
                  width: 35,
                  height: 35,
                  backgroundColor: "transparent",
                  color: colors.primary,
                  borderColor: colors.primary,
                  borderWidth: 1,
                  borderRadius: "50%",
                }}
                onClick={() => {
                  openMultipleAssessmentModal(rowData, true);
                }}
              />
              </>
            )}
            {reportSheet && (
              <Button
                icon="pi pi-id-card"
                style={{
                  width: 35,
                  height: 35,
                  backgroundColor: "transparent",
                  color: "#6366F1",
                  borderColor: "#6366F1",
                  borderWidth: 1,
                  borderRadius: "50%",
                }}
                onClick={() => getStudentReportScreen(rowData)}
              />
            )}
          </>
        ) : hasPaid && !isPromotionList ? (
          <>
            {/* go to profile */}
            <Button
              icon="pi pi-eye"
              style={{
                width: 35,
                height: 35,
                backgroundColor: "transparent",
                color: "#22C55E",
                borderColor: "#22C55E",
                borderWidth: 1,
                borderRadius: "50%",
              }}
              onClick={() => goToProfile(rowData)}
            />
          </>
        ) : isPromotionList ? (
          // promote student
          <Button
            icon="pi pi-forward"
            style={{
              width: 35,
              height: 35,
              backgroundColor: "transparent",
              color: colors.primary,
              borderColor: colors.primary,
              borderWidth: 1,
              borderRadius: "50%",
            }}
            onClick={() => promoteStudent(rowData)}
          />
        ) : (
          // activate student
          <>
            <Button
              icon="pi pi-wallet"
              style={{
                width: 35,
                height: 35,
                backgroundColor: "transparent",
                color: colors.danger,
                borderColor: colors.danger,
                borderWidth: 1,
                borderRadius: "50%",
              }}
              onClick={() => openPaymentAlert(rowData)}
            />
          </>
        )}
      </div>
    );
  };

  const checkBoxBodyTemplate = (rowData) => {
    const studentId = !empty(rowData) && !empty(rowData._id) ? rowData._id : "";
    const hasPaid =
      !empty(rowData) && !empty(rowData.paid) && rowData.paid === "Yes"
        ? true
        : false;
    return !hasPaid || isPromotionList ? (
      <Checkbox
        checked={selectedStudentIds.includes(studentId)}
        onChange={() => {
          updateSelectedStudentIds(studentId);
        }}
      />
    ) : (
      <FaCheck color={colors.success} />
    );
  };

  const regNoBodyTemplate = (rowData) => {
    const regNo = !empty(rowData) && !empty(rowData.regNo) ? rowData.regNo : "";
    const studentId = !empty(rowData) && !empty(rowData._id) ? rowData._id : "";
    return (
      <NavLink
        to={`/student/${studentId}/profile`}
        style={{ color: colors.primary, textDecoration: "none" }}
      >
        {regNo}
      </NavLink>
    );
  };

  const header = renderHeader();
  // render checkbox column
  const rendexCheckbox =
    (isClassList && !activateEmpty) || isPromotionList ? true : false;
  return (
    <div className="datatable">
      <DataTable
        value={students}
        paginator
        rows={rows}
        header={header}
        filters={filters}
        onFilter={(e) => setFilters(e.filters)}
        selection={selectedStudent}
        onSelectionChange={(e) => setSelectedStudent(e.value)}
        selectionMode="single"
        dataKey="_id"
        stateStorage="session"
        stateKey="dt-state-demo-local"
        emptyMessage="No students found."
        tableStyle={{ minWidth: "100%" }}
        onPage={onPageChange}
        lazy={true}
        totalRecords={totalRecords}
        first={first}
      >
        {rendexCheckbox && !graduationList ? (
          <Column
            field="_id"
            header={
              <Checkbox
                checked={checked}
                onChange={(e) => {
                  setChecked(e.checked);
                  if (e.checked) {
                    setShowAddButton(true);
                    setSelectedStudentIds(studentIds);
                  } else {
                    setSelectedStudentIds([]);
                    setShowAddButton(false);
                  }
                }}
              />
            }
            style={{ width: "5%" }}
            body={checkBoxBodyTemplate}
          />
        ) : null}
        <Column
          field="regNo"
          header="Reg. No."
          sortable
          filterPlaceholder="Search"
          style={{ width: "10%" }}
          body={regNoBodyTemplate}
        ></Column>
        <Column
          field="lastName"
          header="Last Name"
          sortable
          filterPlaceholder="Search"
          style={{ width: "15%" }}
          body={(rowData) => rowData.lastName}
        ></Column>
        <Column
          field="firstName"
          header="First Name"
          sortable
          filterPlaceholder="Search"
          style={{ width: "15%" }}
          body={(rowData) => rowData.firstName}
        ></Column>
        <Column
          field="middleName"
          header="Middle Name"
          sortable
          filterPlaceholder="Middle name"
          style={{ width: "15%" }}
          body={(rowData) => rowData.middleName}
        ></Column>
        {!isClassList && !graduationList ? (
          <Column
            field="class"
            header="Class"
            sortable
            filterPlaceholder="Class"
            style={{ width: "15%" }}
            body={(rowData) => rowData.class}
          ></Column>
        ) : null}
        {!graduationList && (
          <Column
            field="status"
            header="Status"
            body={statusBodyTemplate}
            sortable
            filterMenuStyle={{ width: "14rem" }}
            style={{ width: "10%" }}
          ></Column>
        )}
        {!graduationList && (
          <Column
            header="Action"
            body={actionBodyTemplate}
            exportable={false}
            style={{ width: "15%" }}
          ></Column>
        )}
      </DataTable>
    </div>
  );
}
